<template>
  <!--我的兑换码-->
  <section class="com-b-wrap" style="border-radius: 10px;padding-top: 15px">
    <div class="myCdkey">
        <el-row>
          <el-col :span="6" class="flexcont" style="padding-left: 20px">
            <span>活动名称：</span>
            <el-input v-model="activeName" placeholer="请输入活动名称" size="small"></el-input>
          </el-col>
          <el-col :span="12" class="flexcont" style="justify-content: start">
            <span>冻结状态：</span>
            <el-select v-model="frozenState" placeholder="请选择" size="small">
              <el-option
                v-for="item in frozenOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <span>使用状态：</span>
            <el-select v-model="useStatus" placeholder="请选择" size="small">
              <el-option
                v-for="item in useOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-button @click="getCdkeyList" size="small" class="textBtn" style="margin-left: 20px">查询</el-button>
          </el-col>
          <el-col :span="6" style="text-align: end;padding-right: 30px">
            <!-- <el-button size="small" class="textBtn2" @click="exportExcel">导出excel</el-button> -->
            <el-button size="small" class="handle" @click="cdkeyDialog = true,reset()">生成兑换码</el-button>

          </el-col>
        </el-row>
        <div class="cdkeyCont">
          <el-table :data="cdkeyList" class="cdkeyTable" v-loading="tableLoading">
            <div style="text-align: center" slot="empty">
              <img src="../../../static/img/noData.png" style="width: 225px;height: 160px;margin: 25px auto 0">
              <p>暂无数据</p>
            </div>
            <el-table-column
              prop="cardNo"
              label="兑换码"
              show-overflow-tooltip
              align="center">
            </el-table-column>

              <el-table-column
                prop="activityName"
                label="活动名称"
                show-overflow-tooltip
                align="center">
              </el-table-column>

            <el-table-column
              prop="freezeDate"
              label="冻结状态"
              show-overflow-tooltip
              align="center">
              <template slot-scope="scope">
                {{(scope.row.freezeDate && scope.row.freezeDate > Date.parse(new Date())) ? '已冻结' : (scope.row.freezeDate && scope.row.freezeDate < Date.parse(new Date())) ? '解除冻结' : '未冻结' }}
              </template>
            </el-table-column>
            <el-table-column
              label="使用状态"
              show-overflow-tooltip
              align="center">
              <template slot-scope="scope">
                {{scope.row.useStatus === 0 ? '未使用' : scope.row.useStatus === 1 ? '已使用' :  scope.row.useStatus === 2 ? '已过期' :scope.row.useStatus === 5?'积分退还': '其他'}}
              </template>
            </el-table-column>
            <el-table-column
              prop="useUserName"
              label="用户名称"
              show-overflow-tooltip
              align="center">
            </el-table-column>
            <el-table-column
              prop="useUserMobileOrEmail"
              label="邮箱/手机"
              show-overflow-tooltip
              align="center">
            </el-table-column>
            <el-table-column
              label="使用时间"
              show-overflow-tooltip
              align="center">
              <template slot-scope="scope">
                {{scope.row.useTime?format(scope.row.useTime):''}}
              </template>
            </el-table-column>
             <el-table-column
              label="到期时间"
              show-overflow-tooltip
              align="center">
              <template slot-scope="scope">
                {{scope.row.endTime| format}}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center">
              <template slot-scope="scope">
                <!-- <el-popover
                  placement="bottom-end"
                  style="padding: 0!important;"
                  v-if="(!scope.row.freezeDate || scope.row.freezeDate <= Date.parse(new Date())) && scope.row.useStatus !== 1"
                >
                  <div class="transpond">
                    <el-popover
                      placement="left"
                      style="padding: 0!important;width: 100%"
                    >
                      <qrcode-vue :value="QrCode" level="H" size="140"></qrcode-vue>
                      <div slot="reference" @click="getQrcode(scope.row)"><i class="wx"></i>微信</div>
                    </el-popover>
                    <div @click="noteDialog = true,cdkeyInfo = scope.row" style="margin: 0"><i class="note"></i>短信</div>
                  </div>
                  <el-button slot="reference" style="border: 0;background: none" class="operate">转发</el-button>
                </el-popover> -->
                <span class="operate" style="margin-left: 20px" @click="detailDialog = true,getDetail(scope.row.id)">详情</span>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination

            @size-change="sizeChange"
            @current-change="currentChange"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            class="pagination"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      <el-dialog :visible.sync="cdkeyDialog" title="生成兑换码" width="40%" class="cdkeyDialog">
        <el-form ref="cdkey" :rules="cdkeyRules" :model="cdkeyForm" label-width="120px" size="small">
          <el-form-item label="活动名称:" prop="name">
            <el-input v-model="cdkeyForm.name" class="inputName"></el-input>
          </el-form-item>
          <el-form-item label="兑换码金额(元):" prop="money" style="margin-top: 30px">
            <el-input type="number" v-model="cdkeyForm.money" class="inputNum"></el-input>
            <div class="cdKeyItem">
              <div>
                <img src="../../../static/img/money.png">
                <span>对应的积分为：</span>
              </div>
              <p>{{cdkeyForm.money*100}}</p>
              <span>分</span>
            </div>
          </el-form-item>
          <el-form-item label="兑换码数量(个):" prop="number" style="margin-top: 30px">
            <el-input v-model="cdkeyForm.number" type="number"  class="inputNum"></el-input>
            <div class="cdKeyItem">
              <div>
                <img src="../../../static/img/money.png">
                <span>消耗总积分为：</span>
              </div>
              <p>{{cdkeyForm.number*cdkeyForm.money*100}}</p>
              <span>分</span>
            </div>
          </el-form-item>

           <el-form-item label="到期时间:" prop="endTime">
            <el-date-picker
                v-model="cdkeyForm.endTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                placeholder="选择日期">
              </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button size="small" @click="reset" style="border: 1px solid rgba(2, 47, 74, 0.26);;border-radius: 2px;color: #022F4A;width: 100px;">重设</el-button>
          <el-button size="small" @click="submit" style="border: 1px solid #00B1FF;border-radius: 2px;color: #ffffff;width: 100px;background: #00B1FF">提交</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="successDialog" title="生成兑换码成功" width="35%">
        <div class="createSuccess">
          <img src="../../../static/img/create.png">
          <p>生成兑换码个数：<span>{{cdkeyForm.number}}</span>个&nbsp;&nbsp;&nbsp;&nbsp;总共消耗积分数：<span>{{cdkeyForm.number*cdkeyForm.money*100}}</span>分</p>
        </div>
        <span slot="footer">
          <el-button size="small" @click="successDialog = false,getCdkeyList()" class="close">关闭</el-button>
          <el-button size="small" @click="successDialog = false,getCdkeyList()" class="check">查看</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="detailDialog" title="详情" width="35%">
        <div class="detail">
          <span>兑换码：</span>
          <p>{{cardNo}}，可兑换积分 <span class="point">{{point}}</span> 分</p>
        </div>
        <!-- <div class="detail">
          <span>转发记录：</span>
          <div>
            <p v-for="item in transpondList">{{format(item.forwardTime)}} 通过{{item.forwardType === 1 ? '微信转发' : '短信转发，手机号：'}} {{item.targetId}}</p>
          </div>
        </div> -->
        <div class="detail">
          <span>使用记录：</span>
          <p v-if="useTime">{{useTime}} 兑换领用，使用人：{{useUserName}}</p>
        </div>
        <span slot="footer">
          <el-button class="check" @click="detailDialog = false">关闭</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="noteDialog" title="短信转发" width="30%">
        <div style="display: flex;align-items: center">
          <p style="width: 20%;text-align: right">您的姓名：</p>
          <el-input v-model="noteName" placeholder="请输入您的姓名" style="width: 70%" size="small"></el-input>
        </div>
        <div style="display: flex;align-items: center;margin-top: 20px;">
          <p style="width: 20%;text-align: right">转发到：</p>
          <el-input v-model="notePhone" placeholder="请输入手机号" style="width: 70%" size="small"></el-input>
        </div>
        <span slot="footer">
          <el-button size="mini" type="text" style="ccolor: rgba(2, 47, 74, 0.65);" @click="noteDialog = false">取消</el-button>
          <el-button size="mini" class="handle" @click="noteSubmit(cdkeyInfo)">提交</el-button>
        </span>
      </el-dialog>
    </div>
  </section>
</template>

<script>
  import http from '@/http'
  import QrcodeVue from 'qrcode.vue'
  export default {
    name: "ExchangeCode",
    components: { QrcodeVue},
    data() {
      return {
        activeName: '',
        //冻结状态
        frozenOptions: [{
          value: '',
          label: '全部'
        }, {
          value: '0',
          label: '未冻结'
        }, {
          value: '1',
          label: '已冻结'
        }, {
          value: '2',
          label: '解除冻结',
        }],
        //使用状态
        useOptions: [{
          value: '',
          label: '全部'
        }, {
          value: '0',
          label: '未使用'
        }, {
          value: '1',
          label: '已使用'
        },
        {
          value: '5',
          label: '积分退还'
        }],
        useStatus: '',
        frozenState: '',
        cdkeyList: [],
        page: 1,
        pageSize: 10,
        total: 0,
        cdkeyDialog: false,
        //查询条件
        cdkeyForm: {
          name: '',
          money: '',
          number: '',
          endTime:''
        },
        cdkeyRules: {
          name: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
          ],
          money: [
            { required: true, message: '请输入大于0的整数', trigger: 'change' }
          ],
          number: [
            { required: true, message: '请输入大于0的整数', trigger: 'change' }
          ],
          endTime:[
             { required: true, message: '请输入到期时间', trigger: 'change' }
          ]
        },
        successDialog: false,
        detailDialog: false,
        point: 0,//积分
        cardNo: '',//兑换码
        transpondList: [],//转发记录
        useTime: '',//使用时间
        useUserName: '',//使用人
        noteDialog: false,
        cdkeyInfo: {},//兑换码信息
        noteName: '',//转发人姓名
        notePhone: '',//转发手机号
        QrCode: '',
        pickerOptions: {
          disabledDate(time) {
          return time.getTime() < Date.now()- 8.64e7;
          }
        },
        tableLoading: false
      }
    },
    created() {
      this.getCdkeyList()
    },
    methods: {
      sizeChange(val) {
        this.pageSize = val
        this.getCdkeyList()
      },
      currentChange(val) {
        this.page = val
        this.getCdkeyList()
      },
      //导出
      exportExcel() {
        var _this = this
        let url = _this.globalConfig.domain.backstage + "/activity/exportActivity?activityName=" + _this.activeName + '&useStatus=' + _this.useStatus + '&frozenState=' + _this.frozenState
        http.download(url,(response) => {});
      },
      //获取、查询列表
      getCdkeyList() {
        var _this = this
        var formData = new FormData
        formData.userId = _this.$store.getters.userId
        formData.activityName = _this.activeName
        formData.useStatus = _this.useStatus
        formData.frozenState = _this.frozenState
        formData.page = _this.page
        formData.pageSize = _this.pageSize
        this.tableLoading=true;
        http.post(_this.globalConfig.domain.backstage + "/activity/activityPage",formData ,(response) => {
          this.tableLoading=false;
          if (response.data && response.data.success) {
            var data = response.data.data
            _this.cdkeyList = data.list
            _this.page = data.pageNum
            _this.pageSize = data.pageSize
            _this.total = data.total
          } else {
            _this.$message.error(response.data.description)
          }
        });
      },
      //重置
      reset() {
        this.cdkeyForm = {
          name: '',
          money: '',
          number: '',
        }
      },
      //提交生成兑换码
      submit() {
        this.$refs.cdkey.validate((valid) => {
          if (valid) {
            var formData = new FormData
            // formData.startTime = new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1).toString() + '-' + new Date().getDate().toString() + ' ' + new Date().getHours().toString() + ':' + (new Date().getMinutes()+1).toString() + ':' + new Date().getSeconds().toString()
            formData.createUser = this.$store.getters.userId
            formData.createUserName = this.$store.getters.userName
            // formData.endTime = (new Date().getFullYear() + 50).toString() + '-' + (new Date().getMonth()+1).toString() + '-' + new Date().getDate().toString() + ' ' + '00:00:00'
            formData.activityName = this.cdkeyForm.name
            formData.point = this.cdkeyForm.money*100
            formData.price = this.cdkeyForm.money * this.cdkeyForm.number
            formData.nums = this.cdkeyForm.number
            formData.endTime=this.cdkeyForm.endTime
            debugger
            http.postJson(this.globalConfig.domain.backstage + "/activity/recordActivity",formData ,(response) => {
              if (response.data && response.data.success) {
                this.$message.success(response.data.description || '生成成功')
                this.cdkeyDialog = false
                this.successDialog = true
                this.page=1;
                this.getCdkeyList()
              } else {
                this.$message.error(response.data.description || '生成失败')
              }
            });
          } else {
            return false
          }
        })
      },
      getDetail(id) {
        this.point = 0
        this.cardNo = ''
        this.transpondList = []
        this.useTime = ''
        this.useUserName = ''
        var formData = new FormData
        formData.activityCardId = id
        http.post(this.globalConfig.domain.backstage + "/activity/activityCardDetail",formData ,(response) => {
          if (response.data && response.data.success) {
            let data = response.data.data
            this.point = data.point
            this.cardNo = data.cardNo
            if (data.useTime) {
              this.useTime = this.format(data.useTime)
            } else {
              this.useTime = ''
            }
            this.transpondList = data.forwardRecords || []
            this.useUserName = data.useUserName || ''
          } else {
            this.$message.error('获取详情失败')
          }
        });
      },
      add0(m){
        return m<10?'0'+m:m
      },
      format(shijianchuo) {
        var time = new Date(shijianchuo);
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        return y+'-'+this.add0(m)+'-'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm);
      },
      getQrcode(row) {
        this.QrCode = encodeURI(window.location.origin + '/transpond.html?name=' + this.$store.getters.userName + '&activityCard=' + row.cardNo + '&activityCardId=' + row.id + '&userId=' + this.$store.getters.userId)
      },
      //短信转发
      noteSubmit(row) {
        var formData = new FormData
        formData.activityCard = row.cardNo
        formData.name = this.noteName
        formData.targetId = this.notePhone
        formData.url = encodeURI(this.globalConfig.domain.front + '/transpond.html?name=' + this.noteName + '&activityCard=' + row.cardNo + '&activityCardId=' + row.id + '&userId=' + this.$store.getters.userId)
        http.post(this.globalConfig.domain.backstage + "/activity/activityCardSmsNotify",formData ,(response) => {
          if (response.data && response.data.success) {
            this.getFreeze(row)
          } else {
            this.$message.error('转发失败')
          }
        });
      },
      // 上传转发信息
      getFreeze(row) {
        var formData = new FormData
        formData.activityCardId = row.id
        formData.forwardType = 2
        formData.targetId = this.notePhone
        formData.forwardContactWay = this.noteName
        http.post(this.globalConfig.domain.backstage + "/activity/activityCardFreeze",formData ,(response) => {
          if (response.data && response.data.success) {
            this.noteDialog = false
            this.$message.success('转发成功')
            this.noteName = ''
            this.notePhone = ''
            this.getCdkeyList()
          } else {
            this.$message.error('转发失败')
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  /deep/.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color: #E6F8FF;
  }
  /deep/.el-select-dropdown__item.selected{
    color: #00B1FF;
  }
  /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #E6F8FF;
  }
  .myCdkey {
    width: 100%;
    min-height: 750px;
    background: #ffffff;
    margin: 10px auto 0;

    .flexcont {
      display: flex;
      align-items: center;

      span {
        display: inline-block;
        width: 110px;
      }
    }

    .handle {
      background: #00B1FF;
      color: #FFFFff;
    }
    .handle:hover {
      background: rgba(0, 177, 255, 0.1);
      color: #00b1ff;
    }
    .textBtn {
      width: 100px;
      height: 30px;
      border: 1px solid rgba(2, 47, 74, 0.25);
      border-radius: 2px;
      color: #022F4A;
      padding: 0;
      background: none;
    }
    .textBtn:hover {
      background: rgba(0, 177, 255, 0.1);
      color: #00b1ff;
    }
    .textBtn2 {
      width: 100px;
      height: 30px;
      border: 1px solid #00b1ff;
      border-radius: 2px;
      color: #00b1ff;
      padding: 0;
      background: none;
    }
    .textBtn2:hover {
      background: rgba(0, 177, 255, 0.1);
      color: #00b1ff;
      border: 1px solid rgba(2, 47, 74, 0.25)
    }
    .cdkeyCont {
      margin-top: 20px;
      padding: 0 30px 0 20px;
      position: relative;

      .cdkeyTable {
        width: 100%;
        max-height: 551px;
        overflow-y: auto;

        .operate {
          font-size: 14px;
          font-weight: bold;
          color: #00B1FF;
          cursor: pointer;

          &:hover {
            opacity: 0.6;
          }
        }
      }
      .pagination {
        position: absolute;
        right: 30px;
        bottom: -70px;
      }
    }
  }
  .cdkeyDialog {

    .cdKeyItem {
      width: 235px;
      height: 30px;
      padding: 0 10px;
      background: rgba(252,237,230,0.7);
      border-radius: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-left: 25px;
      font-size: 18px;
      font-weight: bold;
      color: #F99900;

      div {
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }
      span {
        font-size: 14px;
        color: #022F4A;
        font-weight: 400;
      }
      p {
        max-width: 92px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .inputName {
      width: 470px;
    }
    .inputNum {
      width: 200px;
    }
  }
  .createSuccess {
    width: 550px;
    height: 186px;
    margin: 0 auto;
    padding: 22px 0;
    text-align: center;
    border: 1px dashed #CBE0FD;
    border-radius: 4px;

    img {
      width: 220px;
      height: 130px;
    }
    p {
      font-size: 16px;
      font-weight: bold;
      color: #022F4A;
      margin-top: 30px;

      span {
        font-size: 22px;
        color: #F99900;
      }
    }
  }
  .close {
    border: 1px solid #ffffff;
    color: rgba(2, 47, 74, 0.65);
  }
  .check {
    background: #00B1FF;
    color: #FFFFff;

    &:hover {
      background: rgba(0, 177, 255, 0.1);
      color: #00b1ff;
    }
  }
  .detail {
    display: flex;
    font-size: 14px;
    color: #022F4A;
    margin-bottom: 20px;

    span {
      font-weight: bold;
    }
    .point {
      font-size: 16px !important;
      color: #F99900;
    }
  }
  .transpond {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    div {
      width: 100%;
      height: 35px;
      color: #022F4A;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        color: #00B1FF;
        background: #E6F8FF;

        .wx {
          width: 20px;
          height: 20px;
          background: url("../../../static/img/wxHover.png") no-repeat;
          background-size: 100% 100%;
        }
        .note {
          width: 20px;
          height: 20px;
          background: url("../../../static/img/noteHover.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .wx {
      width: 20px;
      height: 20px;
      background: url("../../../static/img/wx.png") no-repeat;
      background-size: 100% 100%;
      margin-right: 10px;
    }
    .note {
      width: 20px;
      height: 20px;
      background: url("../../../static/img/note.png") no-repeat;
      background-size: 100% 100%;
      margin-right: 10px;
    }
  }
  /deep/ .el-table td {
    width: 12.5% !important;
  }
  /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
  }
  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #EEEEEE;
  }

  .my-link{
    cursor: pointer;
    margin-right: 20px;
    &:last-child{
      margin-right: 0;
    }
    &:hover{
      color: #00B1FF;
      opacity: 0.6;
    }
    &.active{
      color: #00B1FF;
    }
  }
 /deep/ .el-pager li.active{
    border: 1px solid #00B1FF;
  }
  /deep/ .el-pager li{
    border: 1px solid rgba(2, 47, 74, 0.25098039215686274);
    margin-right: 10px;
  }
  /deep/ .el-pagination .btn-prev{
    border: 1px solid rgba(2, 47, 74, 0.25098039215686274);
    margin-right: 10px;
  }
  /deep/ .el-pagination .btn-next{
    border: 1px solid rgba(2, 47, 74, 0.25098039215686274);
    margin-right: 10px;
  }
  /deep/.el-pager li.active+li{
    border-left: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/components/ExchangeCode.vue